/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInterestSettings} from '../api'

 export const useQueryGetInterestSettings = createReactQueryHook('getInterestSettings', getInterestSettings)
